import { DynamicPage, getDynamicPageProps } from '~/templates/pages/components/DynamicPage/DynamicPage';

export const getServerSideProps = getDynamicPageProps;
export default DynamicPage;
